import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "日期", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "导出", -1)
const _hoisted_5 = { class: "flex flexC mar-t-22" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.screenParameter.date_array,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.screenParameter.date_array = $event)),
        class: "mar-r-18",
        type: "daterange",
        align: "right",
        "unlink-panels": "",
        "range-separator": "-",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenChange($event, 'time'))),
        "value-format": "x"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "bg-red",
        onClick: _ctx.exportChange
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass,
        "cell-class-name": _ctx.setCellColor,
        onCellClick: _ctx.cellClick,
        "summary-method": _ctx.getSummaries,
        "show-summary": ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              class: "c-red",
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width,
              key: index
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data", "header-cell-style", "cell-class-name", "onCellClick", "summary-method"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: _ctx.dialogTitle[_ctx.dialogType],
      "model-value": _ctx.dialogType > -1,
      width: '1000px',
      "before-close": 
                () => {
                    _ctx.dialogType = -1;
                }
            ,
      center: ""
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_el_table, {
          data: _ctx.dialogData.tableData,
          stripe: "",
          style: {"width":"100%"},
          class: "table",
          "header-cell-style": _ctx.headClass
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dialogTableData.columnList, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                class: "c-red",
                align: "center",
                prop: item.prop,
                label: item.label,
                "min-width": item.width,
                key: index
              }, null, 8, ["prop", "label", "min-width"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["data", "header-cell-style"]), [
          [_directive_loading, _ctx.loading]
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_el_pagination, {
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            "current-page": _ctx.dialogData.page,
            "page-sizes": [10, 20],
            "page-size": _ctx.dialogData.pageSize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _ctx.dialogData.total
          }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    }, 8, ["title", "model-value", "before-close"])
  ]))
}